/** @format */
import { ReactElement, ReactNode } from 'react';

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type ProductTrustCardProps = {
    heading: string;
    icon: ReactElement;
    children: ReactNode;
    'data-testid'?: string;
    className?: string;
    variant?: ProductTrustCardVariant;
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    withKeyline?: boolean;
};

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type ProductTrustCardSkeletonProps = {
    className?: string;
    'data-testid'?: string;
    children?: ReactNode;
};

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum ProductTrustCardVariant {
    SUN = 'SUN',
    WHITE = 'WHITE',
}

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type StyledProductTrustCardProps = Pick<
    ProductTrustCardProps,
    'data-testid' | 'className' | 'variant'
>;
